export const cursorColors = [
    '#DC2626',
    '#EA580C',
    '#D97706',
    '#CA8A04',
    '#65A30D',
    '#16A34A',
    '#059669',
    '#0D9488',
    '#0891B2',
    '#0284C7',
    '#2563EB',
    '#4F46E5',
    '#7C3AED',
    '#9333EA',
    '#C026D3',
    '#DB2777',
    '#E11D48'
];

type ElementWithType = { type: string; children: unknown[]; id?: string; };

export function isElementWithType<T extends ElementWithType = ElementWithType>(value: unknown, type?: string): value is T {
    return typeof value === 'object' && value !== null && 'type' in value && (type === undefined || value.type === type);
}

export function generateSlug(input: string): string {
    // 1. Normalize (NFD) and remove diacritical marks
    let slug = input
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''); // Remove diacritical marks
  
    // 2. Convert to lowercase
    slug = slug.toLowerCase();
  
    // 3. Replace all non-alphanumeric characters with '-'
    slug = slug.replace(/[^a-z0-9]+/g, '-');
  
    // 4. Remove any leading or trailing '-'
    slug = slug.replace(/^-+|-+$/g, '');
  
    return slug;
}

export function getRandomCursorColor(): string {
    return cursorColors[Math.floor(Math.random() * cursorColors.length)];
}
